import beyondAerospace from "../assets/beyond_aerospace.svg";
import cubeLogo from "../assets/cube.png";
import eigLogo from "../assets/eig.png";
import trainingPortLogo from "../assets/trainingport.png";
const CustomerLogos = () => {
  const logos = [
    {
      type: "image",
      src: "https://dataspeckle.com/assets/images/brand-elements/logo-v.svg",
      link: "https://dataspeckle.com/",
      alt: "DataSpeckle Logo",
    },
    {
      type: "image",
      src: "https://simacstatic.s3.amazonaws.com/static/homepage/homepage-images/logo.svg",
      link: "https://linax.ca/",
      alt: "Linax Logo",
    },
    {
      type: "image",
      src: "https://knoxmountaindentistry.com/wp-content/uploads/2020/07/black_logo.png",
      link: "https://www.knoxmountaindentistry.com",
      alt: "Knox Mountain Dentistry Logo",
    },
    {
      type: "image",
      src: "https://ascenddentaleducation.com/wp-content/uploads/2024/06/ascend_dental_logo.png",
      link: "https://ascenddentaleducation.com/",
      alt: "Ascend Dental Education Logo",
    },
    {
      type: "image",
      src: trainingPortLogo,
      link: "https://www.trainingport.net/",
      alt: "Training Port Logo",
    },
    {
      type: "svg-file",
      src: beyondAerospace,
      link: "https://www.beyondaerospace.com/",
      alt: "Beyond Aerospace Logo",
    },
    {
      type: "image",
      src: "https://www.createasoft.com/Portals/0/CreateASoft_Logo_DigitalTwinAndAI.png?ver=EDc6pAscgUf3PNrFrPLC5g%3d%3d",
      link: "https://www.createasoft.com/",
      alt: "Create a soft Logo",
    },
    {
      type: "image",
      src: cubeLogo,
      link: "https://cubemc.com/",
      alt: "Cube mc Logo",
    },
    {
      type: "image",
      src: "https://www.thescrmconsortium.com/hs-fs/hubfs/SCRM%20Website%20logo-3.png?width=400&height=130&name=SCRM%20Website%20logo-3.png",
      link: "https://www.thescrmconsortium.com/",
      alt: "SCRM Logo",
    },
    {
      type: "image",
      src: "https://images.squarespace-cdn.com/content/v1/6299456e53355625420b34b3/0d682d3f-9f3a-439f-abc3-6e7506aa1293/ALC-vert-trans-lg.png",
      link: "https://www.kelownachiro.ca/",
      alt: "Active Living Logo",
    },
    {
      type: "image",
      src: eigLogo,
      link: "https://consultingeig.com/",
      alt: "Consulting EIG Logo",
    },
    {
      type: "image",
      src: "https://copperbrewingco.com/wp-content/uploads/2023/09/copper-brewing-logo.png",
      link: "https://copperbrewingco.com/",
      alt: "Copper Brewing Logo",
    },
    {
      type: "image",
      src: "https://www.ravencsi.com/wp-content/uploads/2026/01/raven-logo%E2%94%AC-big-tag-CSI-removed-e1743470800573.jpg",
      link: "https://ravencsi.com/",
      alt: "Raven CSI Logo",
    },
  ];

  const renderLogo = (logo, index) => {
    switch (logo.type) {
      case "image":
      case "svg-file":
        const isTrainingPort = logo.src === trainingPortLogo;
        return (
          <img
            src={logo.src}
            alt={logo.alt}
            className={`h-20 w-20 sm:h-24 sm:w-24 object-contain ${
              isTrainingPort ? "bg-[#374a64]" : ""
            }`}
          />
        );
      case "svg-inline":
        const SvgComponent = logo.src;
        return (
          <SvgComponent
            className="h-20 w-20 sm:h-24 sm:w-24 object-contain"
            aria-label={logo.alt}
          />
        );
      default:
        return null;
    }
  };

  const duplicatedLogos = [...logos, ...logos, ...logos];

  return (
    <section className="bg-white dark:bg-gray-900">
      <div className="py-8 lg:py-16 mx-auto max-w-screen-2xl px-4">
        <h2 className="mb-8 lg:mb-16 text-3xl md:text-4xl font-serif font-bold tracking-tight leading-tight text-center text-gray-900 dark:text-white">
          Trusted By
        </h2>
        <div className="flex overflow-hidden space-x-6 sm:space-x-8 md:space-x-10 lg:space-x-12 group">
          <div className="flex space-x-6 sm:space-x-8 md:space-x-10 lg:space-x-12 animate-loop-scroll group-hover:paused">
            {duplicatedLogos.map((logo, index) => (
              <a
                key={index}
                href={logo.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex justify-center items-center"
              >
                <div className="h-20 w-20 sm:h-24 sm:w-24 flex justify-center items-center">
                  {renderLogo(logo, index)}
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerLogos;
